const packageName = process.env._PACKAGE_NAME_;
const packageVersion = process.env._PACKAGE_VERSION_;

export const BUILD_VERSION = `${packageName}@${packageVersion}`;
